import { usePostMutation } from "@/api/swr/useMutation";
import { assessorResetPasswordSchema } from "@/schema/console/assessors/AssessorResetPassword";
import { z } from "zod";

type Config = Parameters<
  typeof usePostMutation<typeof assessorResetPasswordSchema, z.ZodNull>
>[3];

export const useAssessorResetPassword = (id: number, config?: Config) => {
  return usePostMutation(
    assessorResetPasswordSchema,
    z.null(),
    `/console/admin_users/${id}/reset_password`,
    config,
  );
};
